import { Injectable } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { IdNomModel } from '../models/IdNomModel';
import { MediaService } from './media.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  constructor(private mediaService: MediaService) {}

  nombreAnneeVisibiliteSportifs: number = 2;
  anneeDebutFormationContinue: number = 2026;

  previsionRealise = {
    prevision: { id: 1, name: 'Prévision' },
    realise: { id: 2, name: 'Réalisé' }
  };

  previsionRealiseArray = [
    { id: 1, name: 'Prévision' },
    { id: 2, name: 'Réalisé' }
  ];

  statutsPrevision = {
    brouillon: { id: 1, name: 'Brouillon', classOutline: 'btn-outline-secondary' },
    propose: { id: 2, name: "Proposé à la Direction de l'établissement", classOutline: 'btn-outline-primary' },
    transmis: { id: 3, name: 'Transmis Ministère', classOutline: 'btn-outline-info' },
    accepte: { id: 4, name: 'Accepté Ministère', classOutline: 'btn-outline-success' },
    refuse: { id: 5, name: 'Refusé Ministère', classOutline: 'btn-outline-danger' }
  };

  statutsRealise = {
    brouillon: { id: 1, name: 'Brouillon', classOutline: 'btn-outline-secondary' },
    propose: { id: 2, name: "Proposé à la Direction de l'établissement", classOutline: 'btn-outline-primary' },
    transmis: { id: 3, name: 'Transmis Ministère', classOutline: 'btn-outline-info' }
  };

  statutsSuiviPrevision = {
    nontransmis: { id: 1, name: 'Non transmis' },
    transmis: { id: 2, name: 'Transmis' },
    traite: { id: 3, name: 'Traité' },
    accepte: { id: 4, name: 'Accepté' }
  };

  portagesSession = {
    seul: { id: 1, name: 'Seul' },
    sousTraitance: { id: 2, name: 'En sous-traitance' },
    partenariat: { id: 3, name: 'En partenariat' }
  };

  pDropdownStyle = {
    width: '100%',
    padding: '2px',
    border: '1px solid #ced4da',
    'font-size': '1rem'
  };

  // tranches d'age : [<18 ans, 18-20[, 20-25[, 25-30[, 30-35[, 35-40[, 40-45[, 45-50[, >50]
  transchesAge = {
    1: '<=17 ans',
    2: '18-19',
    3: '20-24',
    4: '25-29',
    5: '30-34',
    6: '35-39',
    7: '40-44',
    8: '45-49',
    9: '>=50'
  };

  genres = {
    1: { id: 1, name: 'Femme', shortName: 'F' },
    2: { id: 2, name: 'Homme', shortName: 'M' }
  };

  typeDemandes = {
    cpf: { id: 1, name: 'CPF' },
    horsCpf: { id: 2, name: 'Hors CPF' }
  };

  decisionsFormationContinue = {
    acceptee: { id: 1, name: 'Acceptée' },
    refusee: { id: 2, name: 'Refusée' },
    enAttente: { id: 0, name: 'En attente' }
  };

  typesDepenses = {
    pedagogique: { id: 1, name: 'Pédagogiques' },
    distanciel: { id: 2, name: 'Distanciel' },
    indemnite: { id: 3, name: 'Indemnités' }
  };

  // Statuts : Apprenti, Contrat de professionnalisation, Contrat aidé, Fonctionnaire, Indépendant, Demandeur d’emploi, Gratifiable, Autre
  statutsAlternance = {
    1: 'Apprenti',
    2: 'Contrat de prof.',
    3: 'Contrat aidé',
    4: 'Fonctionnaire',
    5: 'Indépendant',
    6: 'Demandeur d’emploi',
    7: 'Gratifiable',
    8: 'Autre'
  };

  //// Origines: Structure commerciale, Association, OPCO, Conseil régional, Autres collectivités, Ministère des sports, Autres ministères, Particulier, Fond propre de l’établissement, Autre
  //originesFiancement = {
  //  1: 'Structure<br/>commerciale',
  //  2: 'Association',
  //  3: 'OPCO',
  //  4: 'Conseil<br/>régional',
  //  5: 'Autres<br/>collectivités',
  //  6: 'Ministère<br/>des sports',
  //  7: 'Autres<br/>ministères',
  //  8: 'Particulier',
  //  9: 'Fond propre<br/>de l’EPF',
  //  10: 'CPF',
  //  11: 'Pôle<br/>emploi',
  //  12: 'Autre'
  //};

  volumesHoraire = {
    Centre: 'En centre',
    Alternance: 'En entreprise',
    Foad: 'Par FOAD'
  };

  statutsSessionFormation = {
    brouillon: { id: 1, name: 'Brouillon' },
    valide: { id: 2, name: 'Validé' }
  };

  statutsSessionFormationContinue = {
    brouillon: { id: 1, name: 'Brouillon' },
    valide: { id: 2, name: 'Validé' }
  };

  typesMedia = {
    logoEtablissement: 1,
    modeleIndicateursNationauxDePerformanceExcel: 2,
    modeleTableauDeBordFormationExcel: 3,
    modeleTableauDeBordBordDirectionSportExcel: 4,
    modeleIndicateursNationauxDePerformanceGraphiqueExcel: 5,
    documentsRealiseDetail: 6,
    aide: 9,
    imageActualite: 10,
    imageAide: 11,
    documentsPrevisionDetail: 13
  };

  typesRealise = {
    int: 1,
    decimal: 2,
    pourcent: 3,
    string: 4,
    longString: 5,
    listeChoixMultiple: 6,
    checkBox: 7,
    volumeHoraireAnnuelIndicateur231: 8,
    upload: 9
  };

  typesPrevision = {
    int: 1,
    decimal: 2,
    pourcent: 3,
    euro: 4,
    upload: 5
  };

  groupeAccordeonValues: IdNomModel[] = [
    { Id: 0, Nom: 'Non' },
    { Id: 1, Nom: 'Oui avec valeur' },
    { Id: 2, Nom: 'Oui avec Libellé' }
  ];

  private _statutsPrevisionList = null;
  get statutsPrevisionList(): IdName[] {
    if (!this._statutsPrevisionList) {
      this._statutsPrevisionList = Object.keys(this.statutsPrevision)
        .map((statutPrevisionIndex) => <IdName>this.statutsPrevision[statutPrevisionIndex])
        .sort((a, b) => (a.id > b.id ? 1 : -1));
    }
    return this._statutsPrevisionList;
  }

  private _statutsRealiseList = null;
  get statutsRealiseList(): IdName[] {
    if (!this._statutsRealiseList) {
      this._statutsRealiseList = Object.keys(this.statutsRealise)
        .map((statutRealiseIndex) => <IdName>this.statutsRealise[statutRealiseIndex])
        .sort((a, b) => (a.id > b.id ? 1 : -1));
    }
    return this._statutsRealiseList;
  }

  public Indicateur10Const = {
    CodeVolume: 'Volume',
    ClasseCalculVolumeHoraireAnnuel: 'CalculVolumeHoraireAnnuel'
  };

  public Indicateur441Const = {
    AnneeV2: 2021,
    MinimumEngagement6: 30,
    CodeAlimentationResponsable: 'AlimentationResponsable',
    CodeMobilitesDurables: 'MobilitesDurables',
    CodeGestionResponsableDesDechets: 'GestionResponsableDesDechets',
    CodeSitesNaturelsEspacesVertsEtBiodiversite: 'SitesNaturelsEspacesVertsEtBiodiversite',
    CodePreservationDesRessourcesEnEauEtEnEnergies: 'PreservationDesRessourcesEnEauEtEnEnergies',
    CodeAchatsDurablesEtResponsables: 'AchatsDurablesEtResponsables',
    CodeExperimentationsEcoResponsables: 'ExperimentationsEcoResponsables',
    CodeAccueilIinclusionEtLutteContreLesDiscriminations: 'AccueilIinclusionEtLutteContreLesDiscriminations',
    CodeImpactEconomiqueEtSocial: 'ImpactEconomiqueEtSocial',
    CodeAncrageTerritorial: 'AncrageTerritorial',
    CodeCauseSolidaireEtCitoyenne: 'CauseSolidaireEtCitoyenne',
    CodeManagementResponsable: 'ManagementResponsable',
    CodeSensibilisation: 'Sensibilisation',
    CodeFormationEEDD: 'FormationEEDD',
    CodeSportifsEngages: 'SportifsEngages',

    CodePourcentage: 'Pourcentage',
    CodeAsPourcentage: 'AsPourcentage',
    CodeValidation: 'Validation',
    CodeContributionRGI: 'ContributionRGI',

    Code441: '16',
    Code15Bis: '16.Bis'
  };

  public Indicateur16Const = {
    CodePlanEthique: 'PlanEthique',
    CodeReferentEi: 'ReferentEi',
    CodeCommunicationEthique: 'CommunicationEthique',
    CodeControleHonorabilite: 'ControleHonorabilite',
    CodePreventionDopage: 'PreventionDopage',
    CodePreventionAtteintesProbite: 'PreventionAtteintesProbite',
    CodeFormationsEtSensibilisations: 'FormationsEtSensibilisations',
    CodeLaicitePreventionSeparatisme: 'LaicitePreventionSeparatisme',
    CodeTraitementSignalements: 'TraitementSignalements',

    CodeTotalType: 'TotalType',
    CodeTotalBeneficiaireType: 'TotalBeneficiaireType',
    CodeTotalBeneficiaireActivite: 'TotalBeneficiaireActivite',

    CodePlanEnVigueur: 'PlanEnVigueur',
    CodeCvssPlenier: 'CvssPlenier',
    CodeSignalement: 'CvssSignalement',
    CodePreciserAxe: 'CvssPreciserAxe',

    CodeValidation: 'Validation',
    CodeSansValidation: 'SansValidation',
    CodeAsPourcentage: 'AsPourcentage'
  };

  public Indicateur15SpeConst = {
    CodeNombreAgents: 'NombreAgents',
    // 6
    CodePartBegesRealisesPublies: 'PartBegesRealisesPublies',
    CodeNombreBegesMoinsTroisAnsPublies: 'NombreBegesMoinsTroisAnsPublies',
    CodeNombreBegesMoinsTroisAnsNonPublies: 'NombreBegesMoinsTroisAnsNonPublies',
    CodeNombreBegesNonRealises: 'NombreBegesNonRealises',
    // 8
    CodePartAgentsFMD: 'PartAgentsFMD',
    CodeNombreAgentsFMD: 'NombreAgentsFMD',
    // 11
    CodePartAgentsIndemnisationIleDeFrance: 'PartAgentsIndemnisationIleDeFrance',
    CodeNombreAgentsIleDeFrance: 'NombreAgentsIleDeFrance',
    CodeNombreAgentsIndemnisationIleDeFrance: 'NombreAgentsIndemnisationIleDeFrance',
    // 14
    CodePartAgentsIndemnisationHorsIleDeFrance: 'PartAgentsIndemnisationHorsIleDeFrance',
    CodeNombreAgentsHorsIleDeFrance: 'NombreAgentsHorsIleDeFrance',
    CodeNombreAgentsIndemnisationHorsIleDeFrance: 'NombreAgentsIndemnisationHorsIleDeFrance',
    // 17
    CodePartParkingsStationnementsVelosSurTotal: 'PartParkingsStationnementsVelosSurTotal',
    CodeNombreTotalParkingsAgents: 'NombreTotalParkingsAgents',
    CodeNombreParkingsStationnementsVelos: 'NombreParkingsStationnementsVelos',
    // 22
    CodePartEmplacementsStationnementsVelosSurTotalVehicules: 'PartEmplacementsStationnementsVelosSurTotalVehicules',
    CodeNombreEmplacementsStationnementVelo: 'NombreEmplacementsStationnementVelo',
    CodeNombreEmplacementsStationnementVehicules: 'NombreEmplacementsStationnementVehicules',
    // 29
    CodeNombreTrajetsAeriensMoyenAgents: 'NombreTrajetsAeriensMoyenAgents',
    CodeNombreTrajetsAllersAvion: 'NombreTrajetsAllersAvion',
    // 34
    CodePartDirectionsReglementUtilisationEnjeux: 'PartDirectionsReglementUtilisationEnjeux',
    CodeNombreDirectionsReglementGestionActualiseMobiliteSobriete: 'NombreDirectionsReglementGestionActualiseMobiliteSobriete',
    CodeNombreTotalDirectionsAvecParcAutomobile: 'NombreTotalDirectionsAvecParcAutomobile',
    // 35
    CodePartDirectionsOdrive: 'PartDirectionsOdrive',
    CodeRespectDeploiementOdrive: 'RespectDeploiementOdrive',
    // 40
    CodeReductionParcAutomobileVehiculesParticuliers: 'ReductionParcAutomobileVehiculesParticuliers',
    CodeNombreVehiculesParticuliers31Decembre: 'NombreVehiculesParticuliers31Decembre',
    CodeNombreVehiculesParticuliers31122021: 'NombreVehiculesParticuliers31122021',
    // 42
    CodePartVehiculesTresFaiblesEmissions31Decembre: 'PartVehiculesTresFaiblesEmissions31Decembre',
    CodeNombreVehiculesParticuliersTresFaiblesEmissions31Decembre: 'NombreVehiculesParticuliersTresFaiblesEmissions31Decembre',
    // 55
    CodePartProduitsAgricultureBiologique: 'PartProduitsAgricultureBiologique',
    CodeMontantTotalAchatsServicesRestaurationCollective: 'MontantTotalAchatsServicesRestaurationCollective',
    CodeMontantAchatsProduitsIssusAgricultureBiologique: 'MontantAchatsProduitsIssusAgricultureBiologique',
    // 57
    CodePartProduitsQualiteDurable: 'PartProduitsQualiteDurable',
    CodeMontantAchatsProduitsQualiteDurable: 'MontantAchatsProduitsQualiteDurable',
    // 58
    CodePartProduitsAgricultureBiologiqueQualiteDurable: 'PartProduitsAgricultureBiologiqueQualiteDurable',
    // 63
    CodePartProduitsAgricultureBiologiqueAchatsFraisBouche: 'PartProduitsAgricultureBiologiqueAchatsFraisBouche',
    CodeMontantTotalAchatsFraisBouche: 'MontantTotalAchatsFraisBouche',
    CodeMontantAchatsProduitsAgricultureBiologique: 'MontantAchatsProduitsAgricultureBiologique',
    // 65
    CodePartProduitsQualiteDurableAchatsFraisBouche: 'PartProduitsQualiteDurableAchatsFraisBouche',
    CodeMontantAchatsProduitsQualiteDurableAchatsFraisBouche: 'MontantAchatsProduitsQualiteDurableAchatsFraisBouche',
    // 66
    CodePartProduitsAgricultureBiologiqueQualite: 'PartProduitsAgricultureBiologiqueQualite',
    // 77
    CodePartEspacesVertsSurfaceSuperieure1000: 'PartEspacesVertsSurfaceSuperieure1000',
    CodeNombreEspacesVertsSurfaceSuperieure1000Labellises: 'NombreEspacesVertsSurfaceSuperieure1000Labellises',
    CodeNombreEspacesVertsSurfaceSuperieure1000: 'NombreEspacesVertsSurfaceSuperieure1000'
  };

  public Indicateur19Const = {
    CodeTauxEncadrementFeminin: 'TauxEncadrementFeminin',
    CodeFemmes: 'Femmes',
    CodeTotal: 'Total',
    CodeTaux: 'Taux',

    CodeValidation: 'Validation',
    CodeSansValidation: 'SansValidation',
    CodeAsPourcentage: 'AsPourcentage'
  };

  public EtablissementGIP = 22;
  public EtablissementDs = 23;
  public EtablissementIfce = 21;

  public IndicateurCode17 = '16.Bis';

  // TinyMCE 6 auto-hébergé (licence MIT, sans clé Tiny Cloud) : fichiers copiés de node_modules/tinymce vers /tinymce (angular.json)
  readonly tinymceBaseInit = {
    base_url: '/tinymce',
    suffix: '.min',
    language: 'fr_FR',
    language_url: '/assets/tinymce/fr_FR.js',
    promotion: false,
    branding: false
  };

  gettinymceInit(typeMedia: number = null) {
    // Sources :
    // https://www.tiny.cloud/docs/configure/file-image-upload/#
    // https://www.tiny.cloud/docs/general-configuration-guide/upload-images/
    // https://codepen.io/nirajmchauhan/pen/EjQLpV
    // https://stackoverflow.com/questions/49098995/how-to-handle-image-upload-in-angular-5-tiny-mce-component

    if (typeMedia == null) {
      return {
        ...this.tinymceBaseInit,
        height: 300,
        menubar: false,
        plugins: ['advlist autolink code lists preview anchor', 'searchreplace visualblocks code fullscreen', 'insertdatetime media table code help wordcount'],
        toolbar:
          'undo redo | formatselect | bold italic underline strikethrough | forecolor backcolor removeformat | \
         alignleft aligncenter alignright alignjustify | fontselect fontsizeselect formatselect | \
         bullist numlist outdent indent | anchor codesample | help'
      };
    }
    return {
      ...this.tinymceBaseInit,
      height: 300,
      menubar: true,
      plugins: ['advlist autolink code lists link image media charmap table preview anchor', 'searchreplace visualblocks code fullscreen', 'insertdatetime media table code help wordcount'],
      toolbar:
        'undo redo | formatselect | bold italic underline strikethrough | forecolor backcolor removeformat | \
       alignleft aligncenter alignright alignjustify | fontselect fontsizeselect formatselect | \
       bullist numlist outdent indent | image media link anchor codesample | help',
      paste_data_images: true,
      automatic_uploads: true,

      images_upload_handler: (blobInfo, success, failure) => {
        // var file = new File([blobInfo.blob()], blobInfo.filename());
        var file = <File>blobInfo.blob();
        this.mediaService.uploadMedia(typeMedia, file, false).subscribe(
          (media) => {
            if (media.Erreur) {
              failure(media.Erreur);
            } else if (media.Media) {
              success(media.Media.Url);
            }
          },
          (_) => {
            failure('Une erreur est survenue lors du téléchargement du fichier.');
          }
        );
      },

      images_upload_credentials: true,
      images_reuse_filename: true,
      file_picker_types: 'image',
      image_advtab: true
    };
  }

  navigation = {
    accueil: <MenuItem>{ label: 'Accueil', icon: 'fa fa-fw fa-home', routerLink: ['/'] },
    saisieDonnees: <MenuItem>{ label: 'Saisie de données', icon: 'fa fa-fw fa-building' },
    formation: <MenuItem>{ label: 'Formation', icon: 'fa fa-fw fa-graduation-cap' },
    formationContinue: <MenuItem>{ label: 'Formation continue des agents', icon: 'fa fa-fw fa-graduation-cap' },
    hautNiveau: <MenuItem>{ label: 'Haut-Niveau', icon: 'fa fa-fw fa-trophy' },
    expertise: <MenuItem>{ label: 'Expertise', icon: 'fa fa-fw fa-grav' },
    gestion: <MenuItem>{ label: 'Gestion', icon: 'fa fa-fw fa-cog' },
    editionFormations: <MenuItem>{ label: 'Edition Formations', icon: '' },
    formationsForomes: <MenuItem>{ label: 'Sessions de formations Forômes', icon: '', routerLink: ['/formation'] },
    autresFormations: <MenuItem>{ label: 'Autres sessions de formations', icon: '', routerLink: ['/formation'] },
    formationsContinues: <MenuItem>{ label: 'Formation continue des agents', icon: '', routerLink: ['/formation-continue'] },
    transmission: <MenuItem>{ label: 'Transmission', icon: 'fa fa-fw fa-cloud-upload', routerLink: ['/transmission'] },
    transmissionPrevision: <MenuItem>{ label: 'Prévision', icon: '', routerLink: ['/transmission/prevision'] },
    transmissionRealise: <MenuItem>{ label: 'Réalisé', icon: '', routerLink: ['/transmission/realise'] },
    validation: <MenuItem>{ label: 'Validation', icon: 'fa fa-fw fa-check-square-o', routerLink: ['/validation'] },
    validationPrevision: <MenuItem>{ label: 'Prévision', icon: '', routerLink: ['/validation/suivi-etablissements'] },
    tableauxDeBord: <MenuItem>{ label: 'Tableaux de bord', icon: 'fa fa-fw fa-pie-chart', routerLink: ['/tableau'] },
    tableauIndicateursNationauxDePerformance: <MenuItem>{ label: 'Indicateurs Nationaux de Performance', icon: '', routerLink: ['/tableau/indicateur'] },
    tableauDeBordEtablissements: <MenuItem>{ label: 'Tableau de bord Etablissements', icon: '', routerLink: ['/tableau/tableau-direction-sports'] },
    tableauDeBordFormations: <MenuItem>{ label: 'Tableau de bord Formations', icon: '', routerLink: ['/tableau/tableau-formation'] },
    administration: <MenuItem>{ label: 'Administration', icon: 'fa fa-fw fa-cogs', routerLink: ['/administration'] },
    roles: <MenuItem>{ label: 'Rôles', icon: '', routerLink: ['/administration/role'] },
    utilisateurs: <MenuItem>{ label: 'Utilisateurs', icon: '', routerLink: ['/administration/utilisateur'] },
    objectifs: <MenuItem>{ label: 'Objectifs', icon: '', routerLink: ['/administration/objectif'] },
    metadataPrevision: <MenuItem>{ label: 'Metadata Prévision', icon: '', routerLink: ['/administration/prevision-metadatas'] },
    metadataRealise: <MenuItem>{ label: 'Metadata Réalisé', icon: '', routerLink: ['/administration/realise-metadatas'] },
    actualites: <MenuItem>{ label: 'Actualités', icon: '', routerLink: ['/administration/actualites'] },
    parametresSite: <MenuItem>{ label: 'Paramètres Site', icon: '', routerLink: ['/administration/parametre'] },
    editionTutoriel: <MenuItem>{ label: 'Edition Tutoriel', icon: '', routerLink: ['/administration/aide'], queryParams: { typeMedia: this.typesMedia.aide } },
    repartitionEtablissements: <MenuItem>{ label: 'Répartition établissements', icon: '', routerLink: ['/administration/etablissement-email'] },
    indicateurSite: <MenuItem>{ label: 'Indicateur Site', icon: '', routerLink: ['/administration/indicateur-site'] },
    mesParametres: <MenuItem>{ label: 'Mes paramètres', icon: 'fa fa-fw fa-cog', routerLink: ['/parametre'] },
    administrationDiplomes: <MenuItem>{ label: 'Diplômes', icon: '', routerLink: ['/administration/diplomes'] },
    alerteMail: <MenuItem>{ label: 'Alertes Mails', icon: 'fa fa-fw fa-envelope', routerLink: ['/alertemail'] },
    gestionEtablissements: <MenuItem>{ label: 'Gestion établissements', icon: 'fa fa-fw fa-building', routerLink: ['/administration/etablissements'] }
  };
}

export interface IdName {
  id: number;
  name: string;
  classOutline: string;
}
